@if (canManageRoles) {
  <h1 mat-dialog-title>{{roleName ? ('roles.management.EditRole' | translate:roleName) : ('roles.management.NewRole' | translate)}}</h1>
}
@if (!canManageRoles) {
  <h1 mat-dialog-title>{{'roles.management.RoleDetails' | translate:roleName}}</h1>
}
<div mat-dialog-content>
  <role-editor #roleEditor [role]="data.role" [allPermissions]="data.allPermissions"></role-editor>
</div>
<div mat-dialog-actions>
  @if (canManageRoles) {
    <button mat-raised-button (click)="roleEditor.save();" color="primary">{{'commands.Save' | translate }}</button>
  }
  @if (canManageRoles) {
    <button mat-raised-button (click)="cancel()" color="warn">{{'commands.Cancel' | translate }}</button>
  }
  @if (!canManageRoles) {
    <button mat-raised-button (click)="cancel()">{{'commands.Close' | translate }}</button>
  }
</div>
